import { handleActions } from 'redux-actions';
import { httpActions } from '@figure/frontlib-onboarding-redux';
import { GET_APPLICATION_DISCLOSURES } from 'actions/disclosure-actions';
// import { DisclosureFileOrder } from 'consts';
import { mergeList } from './util';

const { SUCCESS, REQUEST } = httpActions;

export const initialState = {
  disclosuresByApplicationUuid: {},
  error: '',
};

const disclosureReducer = handleActions(
  {
    [`${GET_APPLICATION_DISCLOSURES}_${REQUEST}`](state = initialState) {
      return {
        ...state,
      };
    },
    [`${GET_APPLICATION_DISCLOSURES}_${SUCCESS}`](state, action) {
      const key = action.payload.applicationUuid;
      const value = state.disclosuresByApplicationUuid[key] || {};
      // const ordering = (disclosure) => DisclosureFileOrder[disclosure.document.type] || 0;

      return {
        ...state,
        disclosuresByApplicationUuid: {
          [key]: {
            ...value,
            ...action.payload,
            disclosuresList: mergeList(value?.disclosuresList, action.payload.disclosuresList),
            // disclosuresList: mergeList(value?.disclosuresList, action.payload.disclosuresList).sort(
            //   (d1, d2) => ordering(d1) - ordering(d2)
            // ),
          },
        },
      };
    },
    //   [`${SIGN_PERSONAL_LOAN_AGREEMENT}_${SUCCESS}`](state, action) {
    //     const { msg, succeeded, referenceDocumentUuid: documentUuid } = action.payload;
    //     if (msg || !succeeded) {
    //       return {
    //         ...state,
    //         error: msg || 'Something unexpected happened',
    //       };
    //     }

    //     const disclosuresList = Object.values(state.disclosuresByApplicationUuid).find((dl) =>
    //       dl.disclosuresList.some((d) => d.document.uuid === documentUuid)
    //     )?.disclosuresList;

    //     if (!disclosuresList) {
    //       return {
    //         ...state,
    //         error: `No disclosure with document ${documentUuid} found`,
    //       };
    //     }

    //     const { applicationUuid } = action.meta;

    //     return {
    //       ...state,
    //       disclosuresByApplicationUuid: {
    //         ...state.disclosuresByApplicationUuid,
    //         [applicationUuid]: {
    //           ...state.disclosuresByApplicationUuid[applicationUuid],
    //           disclosuresList: disclosuresList.map((d) => ({
    //             ...d,
    //             hasEsignature: d.document.uuid === documentUuid ? true : d.hasEsignature,
    //           })),
    //         },
    //       },
    //     };
    //   },
  },
  initialState
);

export default disclosureReducer;
